import {
  parseArraySOC,
  parseBooleanEnabledSOC,
  parseNumberSOC,
} from "src/features/gifts/imports/abTest";
import { serverOwnedConfigSelectors } from "src/features/gifts/imports/selectors";
import { RootState } from "src/features/gifts/imports/types";

export const getIsARGiftsEnabled = parseBooleanEnabledSOC(
  "web.ar.gifts.enabled",
  "0"
);

export const getIsSendGiftBIv2Enabled = parseBooleanEnabledSOC(
  "web.send.gift.bi.v2.enabled",
  "0"
);

export const getIsSendGiftOptimisticEnabled = parseBooleanEnabledSOC(
  "web.send.gift.optimistic.enabled",
  "0"
);

export const getIsGiftPreloadEnabled = parseBooleanEnabledSOC(
  "web.gift.preload.enabled",
  "0"
);

export const getGiftIdsToPreload = parseArraySOC("web.gift.ids.to.preload", "");

export const getMinimumAnimationPrice = parseNumberSOC(
  "web.gift.minimum.animation.price",
  "100"
);

export const getIsComboGiftAnimationEnabled = parseBooleanEnabledSOC(
  "web.gift.combo.animation.enabled",
  "0"
);

export const getComboAnimationDelay = parseNumberSOC(
  "combo.timer.start.animation.duration",
  "3"
);

export const getComboAnimationDuration = parseNumberSOC(
  "combo.timer.duration",
  "10"
);

export const getComboGiftsAmounts = parseNumberSOC(
  "combo.3d.after.gifts.sent",
  "5"
);

export const getGiftAnimationSucessMetricksEnabled = parseBooleanEnabledSOC(
  "web.tracking.gift.animation.success.enabled",
  "0"
);

export const getExcludedGifts = parseArraySOC("combo.exclude.gifts", "");

export const getIsGiftDrawerOptimizationEnabled = parseBooleanEnabledSOC(
  "web.gift.drawer.optimization.enabled",
  "0"
);

export const getDefaultComboUrl = (state: RootState) =>
  serverOwnedConfigSelectors.getConfigParamByKey(
    state,
    "web.combo.animation.source",
    ""
  );
